import { createStore, combineReducers, applyMiddleware } from 'redux'
import createSagasMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import axios from 'axios'

import allSagas from './sagas'
import { API_HOST } from './config'
import allReducers from './reducers'
import { INIT_SAGAS } from './actions'

axios.defaults.baseURL = API_HOST

const history = createBrowserHistory({})
const sagasMiddleware = createSagasMiddleware()
const reducers = combineReducers(allReducers)
const store = createStore(
  reducers,
  applyMiddleware(sagasMiddleware),
)

sagasMiddleware.run(allSagas(history))

const token = localStorage.getItem('token')

if (!token) {
  history.replace('/login')
} else {
  store.dispatch(INIT_SAGAS({ token }))
}

export {
  store,
  history,
}
